import { apiFetch } from '@/lib/api'

export type TileValue = number | string | null

export interface OverviewTile {
  key: string
  title: string
  drill_to: string | null
  value: TileValue
  /** Optional 14-bucket array for sparklines. */
  sparkline?: number[]
  /** Per-tile extras — KPI tiles read these directly without typing. */
  [extra: string]: unknown
}

export interface OverviewResponse {
  generated_at: string
  tiles: OverviewTile[]
}

export interface TimeseriesBucket {
  t: string
  v: number
}

export interface TimeseriesResponse {
  metric: string
  period_days: number
  buckets: TimeseriesBucket[]
}

export interface TopItem {
  id: number | string
  label: string
  value: number
}

export interface TopResponse {
  domain: string
  items: TopItem[]
}

export interface ActivityRow {
  id: number
  actor_username: string | null
  actor_type: string
  action: string
  target_model: string
  target_id: string
  created_at: string
}

export interface ActivityFeedResponse {
  results: ActivityRow[]
  next_cursor: string | null
}

export function fetchOverview(refresh = false): Promise<OverviewResponse> {
  const suffix = refresh ? '?refresh=1' : ''
  return apiFetch<OverviewResponse>(`/api/admin/metrics/overview/${suffix}`)
}

export function fetchTimeseries(
  metric: string,
  periodDays = 14
): Promise<TimeseriesResponse> {
  return apiFetch<TimeseriesResponse>(
    `/api/admin/metrics/timeseries/?metric=${encodeURIComponent(metric)}&period=${periodDays}d`
  )
}

export function fetchTop(
  domain: string,
  n = 10,
  periodDays = 30
): Promise<TopResponse> {
  return apiFetch<TopResponse>(
    `/api/admin/metrics/top/?domain=${encodeURIComponent(domain)}&n=${n}&period=${periodDays}d`
  )
}

export function fetchActivityFeed(
  cursor?: string,
  limit = 50
): Promise<ActivityFeedResponse> {
  const params = new URLSearchParams()
  if (cursor) params.set('cursor', cursor)
  params.set('limit', String(limit))
  return apiFetch<ActivityFeedResponse>(
    `/api/admin/activity/feed/?${params.toString()}`
  )
}
